import { defineStore } from 'pinia';
import { type Vehicle, type VehiclePosition } from '../domain/vehicle';
import { useEntityStore } from '../../common/composables/entityStore';
import { computed } from 'vue';

export const useVehicleStore = defineStore('vehicles', () => {
  const { add, remove, getById, merge, clear, getOrThrow, list, changed } = useEntityStore<Vehicle>(
    {
      eventName: 'vehicle-changed',
      getEntityId: (e) => e.id,
      updateEntity(dest, src) {
        dest.automaticLogYardMoves = src.automaticLogYardMoves;
        dest.capacity = src.capacity;
        dest.packageCapacity = src.packageCapacity;
        dest.proximityRange = src.proximityRange;
        dest.proximityConeAngle = src.proximityConeAngle;
        dest.headingSmoothingTimeMs = src.headingSmoothingTimeMs;
        dest.stationarySpeedThreshold = src.stationarySpeedThreshold;
        dest.neutralTurn = src.neutralTurn;
        dest.reverseDetection = src.reverseDetection;
        dest.packagePickupDirection = src.packagePickupDirection;
        dest.color = src.color;
        dest.description = src.description;
        dest.lastPosition = src.lastPosition;
        dest.name = src.name;
        dest.type = src.type;
        dest.keybinds = src.keybinds;
        dest.lockKeybinds = src.lockKeybinds;
        dest.selectionAnchorPointX = src.selectionAnchorPointX;
        dest.selectionAnchorPointY = src.selectionAnchorPointY;
        dest.anchorRotationOffset = src.anchorRotationOffset;
        dest.usePickupPoint = src.usePickupPoint;
        dest.pickupPointX = src.pickupPointX;
        dest.pickupPointY = src.pickupPointY;
        dest.canMoveFromStorageAreaTypes = src.canMoveFromStorageAreaTypes;
        dest.symbol = src.symbol;
      },
      hasChanged(existing, incoming) {
        return JSON.stringify(existing) !== JSON.stringify(incoming);
      },
    },
  );

  function updatePosition(vehicleId: string, position: VehiclePosition) {
    const vehicle = getById(vehicleId);
    if (!vehicle) return false;
    vehicle.lastPosition = position;
    changed.emit([{
      action: 'updated',
      data: vehicle,
      id: vehicleId,
    }]);
    return true;
  }

  return {
    add,
    remove,
    getById,
    merge,
    clear,
    getOrThrow,
    vehicles: computed(() => list.value),
    changed,
    updatePosition,
  };
});
